/**
 * Step 5 (SEO cleanup): the 10 "keeper" slugs that get full indexing + sitemap inclusion.
 * Every other post is marked <meta name="robots" content="noindex, follow"> and dropped
 * from the sitemap, so Google removes them from the index cleanly instead of diluting
 * topical clarity for the pillar terms we actually want to rank for.
 */
export const KEEPER_SLUGS: readonly string[] = [
  "ms-fatigue-management-complete-guide",
  "what-does-ms-fatigue-feel-like",
  "how-long-does-ms-fatigue-last",
  "does-ms-fatigue-ever-go-away",
  "best-medication-for-ms-fatigue",
  "brain-fog-ms-cognitive-fatigue",
  "ms-heat-sensitivity-energy",
  "best-ms-tracking-apps-2026",
  "spoon-theory-vs-energy-budgeting-ms",
  "weather-changes-ms-fatigue",
] as const;

export const KEEPER_SET = new Set<string>(KEEPER_SLUGS);

export const isKeeper = (slug: string): boolean => KEEPER_SET.has(slug);
